import React from 'react';
import { motion } from 'framer-motion';
import ASCIILogo from './ASCIILogo';

const Hero: React.FC = () => {
  return (
    <section className="hero-section">
      <div className="hero-container">
        <motion.div
          className="ascii-container"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <ASCIILogo width={120} />
        </motion.div>

        <motion.div
          className="hero-content"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.5 }}
        >
          <p className="hero-tagline">
            SOFTWARE ENGINEERING<br />
            <span className="accent">&</span><br />
            CREATIVE PRODUCTION
          </p>
        </motion.div>

        <motion.div
          className="hero-scroll-indicator"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 1 }}
        >
          <span className="scroll-text">[SCROLL]</span>
          <div className="scroll-line" />
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
